<template>
  <div class="boolean-question">
    <FieldLabel :text="question" :disabled="disabled" />

    <div
      v-if="isEditMode"
      class="boolean-question__options mt-2"
      :class="{
        'boolean-question__options--disabled': disabled,
      }"
    >
      <div class="boolean-question__option">
        <input
          type="radio"
          class="boolean-question__option-input"
          :class="{
            'boolean-question__error': error,
          }"
          :data-tourid="`${id}-radio-yes`"
          :id="`${id}_yes`"
          :data-testid="`${name}${tid}_yes`"
          :name="name"
          :value="true"
          :disabled="disabled"
          :checked="value === true"
          @change="handleChange"
        />
        <label class="boolean-question__label" :for="`${id}_yes`">
          {{ yesText }}
        </label>
      </div>

      <div class="boolean-question__option">
        <input
          type="radio"
          class="boolean-question__option-input"
          :class="{
            'boolean-question__error': error,
          }"
          :data-tourid="`${id}-radio-no`"
          :id="`${id}_no`"
          :data-testid="`${name}_no`"
          :name="name"
          :value="false"
          :disabled="disabled"
          :checked="value === false"
          @change="handleChange"
        />
        <label class="boolean-question__label" :for="`${id}_no`">
          {{ noText }}
        </label>
      </div>
    </div>

    <template v-else>
      <p
        v-if="hasValue"
        class="boolean-question__answer ma-0 pa-0"
        :data-testid="`${tid}-answer-label`"
      >
        {{ value === true ? yesText : value === false ? noText : '' }}
      </p>

      <div v-else>
        <v-chip small disabled class="label mt-2">{{
          $t('common.in_progress_status')
        }}</v-chip>
      </div>
    </template>
  </div>
</template>

<script>
import isBoolean from 'lodash/isBoolean'
import FieldLabel from '@/components/Core/FieldLabel'

export default {
  components: {
    FieldLabel,
  },
  props: {
    isEditMode: {
      type: Boolean,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    question: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
      required: false,
    },
    value: {
      type: Boolean,
      required: false,
    },
    yesText: {
      type: String,
      required: true,
    },
    noText: {
      type: String,
      required: true,
    },
    tid: {
      type: String,
      required: false,
      default: 'radio',
    },
    id: {
      type: String,
      required: false,
      default: function() {
        return this.name
      },
    },
    error: Boolean,
  },

  methods: {
    handleChange(event) {
      this.$emit('input', JSON.parse(event.target.value))
    },
  },

  computed: {
    hasValue() {
      return isBoolean(this.value)
    },
  },
}
</script>

<style lang="scss" scoped>
.boolean-question {
  &__question {
    margin-top: 24px;
    margin-bottom: 4px;
    align-self: center;
    font-size: 12px;
    line-height: 16px;
    color: $color-blue-grey-darken1;

    &--disabled {
      opacity: 0.4;
    }
  }

  &__experiment-results {
    align-self: center;
  }

  &__options {
    &--disabled {
      opacity: 0.4;
    }
  }

  &__option {
    display: inline-block;
    margin: 0 16px;

    &-input {
      cursor: pointer;
      -webkit-appearance: none;
      width: 20px;
      height: 20px;
      border: solid 1px $color-blue;
      border-radius: 50%;
      outline: none;
      display: inline-flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      &:before {
        width: 10px;
        height: 10px;
        margin: 0;
        padding: 0;
        content: '';
      }

      &:checked:before {
        background: $color-blue;
        -ms-flex-item-align: center;
        -ms-grid-row-align: center;
        align-self: center;
        border-radius: 50%;
      }
    }
  }

  &__option:nth-child(1) {
    margin-left: 0;
  }

  &__label {
    margin-left: 12px;
    font-size: 12px;
    color: $color-blue-grey-darken3;
    font-style: normal;
    font-weight: normal;
  }

  &__learned {
    margin: 0 auto;
    max-width: 350px;
    height: 100px;
  }

  &__button {
    margin-top: 48px;
  }

  &__answer {
    font-size: 13px;
    margin-bottom: 24px;
  }

  &__error {
    border: solid 1px $color-red;
  }
}
</style>
